// PROPOSITO: avisos (toasts) y estado visual compartido: los avisos y el tema elegido.
// DEPENDENCIAS: zustand, @/lib/tema.
// NO OBVIO: el store guarda y expone; no hace peticiones. Y un aviso nunca miente: solo se llama
// a avisar() con tono exito DESPUES de que la escritura confirmo.
// NO OBVIO (2): el tema arranca leyendo el dispositivo, no un valor fijo. El primer pintado ya lo
// dejo aplicado el script en linea de index.html; aqui solo se refleja para que el selector marque
// la opcion correcta desde el primer render.

import { create } from 'zustand'
import { aplicarTema, leerTemaGuardado, type Tema } from '@/lib/tema'

export type TonoDeAviso = 'exito' | 'error' | 'info'

export interface Aviso {
  id: string
  tono: TonoDeAviso
  texto: string
}

interface EstadoUI {
  avisos: Aviso[]
  tema: Tema
  elegirTema: (tema: Tema) => void
  avisar: (aviso: Omit<Aviso, 'id'>) => void
  descartar: (id: string) => void
}

let contador = 0

export const usarUI = create<EstadoUI>()(set => ({
  avisos: [],
  tema: leerTemaGuardado(),
  elegirTema: tema => {
    aplicarTema(tema)
    set({ tema })
  },
  avisar: aviso => {
    contador += 1
    const id = `aviso-${String(contador)}`
    set(estado => ({ avisos: [...estado.avisos, { ...aviso, id }] }))
    const vidaMs = aviso.tono === 'error' ? 8000 : 4000
    setTimeout(() => {
      set(estado => ({ avisos: estado.avisos.filter(a => a.id !== id) }))
    }, vidaMs)
  },
  descartar: id => {
    set(estado => ({ avisos: estado.avisos.filter(a => a.id !== id) }))
  },
}))
